/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect } from 'react'
import styled, { css } from 'styled-components'
import { useStaticQuery, graphql, navigate } from 'gatsby'

// Libraries
import Select from 'react-select'

// Images
import Upload from 'img/upload.inline.svg'

// Components
import Content from 'components/shared/Content'
import Loading from 'components/shared/Loading'
import ButtonDefaultArrow from 'components/elements/Buttons/ButtonDefaultArrow'
import ButtonWhiteArrow from 'components/elements/Buttons/ButtonWhiteArrow'
import CustomLink from 'components/shared/CustomLink'

// Hooks
import useVacature from 'hooks/useVacature'
import ParseContent from './ParseContent'

const StyledForm = styled.form`
  position: relative;

  & .contact-form {
    & label {
      color: ${({ theme }) => theme.color.secondary} !important;
    }
  }

  .hidden {
    display: none;
  }

  input,
  textarea {
    -webkit-appearance: none;

    &[type='checkbox'] {
      -webkit-appearance: checkbox;
    }

    &[type='radio'] {
      -webkit-appearance: radio;
    }
  }
`

const AlertFormDesc = styled.h2`
  @media (max-width: 991px) {
    font-size: 20px;
  }
`

const ConfirmationMessage = styled(Content)`
  font-size: 24px;
  text-align: center;
  color: ${({ theme }) => theme.color.light};
  font-family: ${({ theme }) => theme.font.family.secondary};
  font-weight: ${({ theme }) => theme.font.weight.bold};
`

const Label = styled.label`
  display: block;
`

const Mandatory = styled.span`
  font-size: 20px;
  color: ${(props) => props.theme.color.secondary};
  margin-left: 5px;
`

const WhiteMandatory = styled.span`
  font-size: 20px;
  color: ${(props) => props.theme.color.light};
  margin-left: 5px;
`

const FileInfo = styled.div`
  color: ${({ theme }) => theme.color.light};
  margin-top: 30px;
`

const LabelRadio = styled.label`
  @media (min-width: 992px) {
    width: 225px;
  }
  @media (max-width: 991.98px) {
    width: 200px;
  }

  @media (max-width: 767.98px) {
    width: 180px;
  }

  @media (max-width: 575.98px) {
    font-size: 12px;
    width: 120px;
  }
`

interface GravityFormProps {
  id: number
  className?: string
}

const GravityForm = ({ className = '', id }: GravityFormProps) => {
  const {
    allGfForm: { edges: gravityData },
  } = useStaticQuery<GatsbyTypes.GravityFormsQueryQuery>(graphql`
    query GravityFormsQuery {
      allGfForm {
        edges {
          node {
            formId
            slug
            apiURL
            descriptionPlacement
            description
            formFields {
              id
              label
              labelPlacement
              description
              descriptionPlacement
              type
              choices
              content
              errorMessage
              inputMaskValue
              isRequired
              visibility
              cssClass
              placeholder
              size
              defaultValue
              maxLength
            }
            button {
              text
            }
            confirmations {
              message
            }
          }
        }
      }
    }
  `)

  const { node: gfForm } = gravityData.filter(
    ({ node }: any) => node.formId === id
  )[0]

  const vacancyName: any = useVacature()

  const [fields, setFields] = useState<any>(
    id === 3 ? { input_7: vacancyName.name } : {}
  )

  const [matchStep, setMatchStep] = useState(0)
  const [form, setForm] = useState<any>(gfForm)
  const [status, setStatus] = useState<string>('')
  const [message, setMessage] = useState<string>('')

  useEffect(() => {
    const tempForm = form

    // add submit button as a field
    if (
      tempForm.formFields.filter((item: any) => item.type === 'submit')
        .length === 0
    ) {
      tempForm.formFields = [
        // @ts-ignore
        ...tempForm.formFields,
        {
          formId: id,
          type: 'submit',
          text: tempForm.button.text,
        },
      ]
    }

    setForm({
      ...form,
      ...tempForm,
    })
  }, [])

  async function handleOnSubmit(event: any) {
    event.preventDefault()

    if (status === 'processing') {
      return
    }

    setStatus('processing')

    try {
      const formData = new FormData()

      Object.keys(fields).forEach((key: string) => {
        formData.append(key, fields[key])
      })

      const request = await fetch(`${form.apiURL}/submissions`, {
        method: 'POST',
        body: formData,
      })

      const response = await request.json()
      if (response.is_valid === true) {
        setStatus('done')

        if (id === 3) {
          navigate('/bedankt')
        }

        if (id === 5) {
          setMessage(response.confirmation_message)
        } else {
          setMessage(response.confirmation_message)
        }
      } else {
        setStatus('error')
      }
    } catch (error) {
      setStatus('error')
    }
  }

  function handleFieldChange(event: any) {
    let { value } = event.target || event.value

    if (event.target) {
      if (event.target.type === 'checkbox') {
        value = event.target.checked ? event.target.value : ''
      }

      if (event.target.type === 'radio') {
        value = event.target.checked ? event.target.value : ''
      }

      setFields({
        ...fields,
        [event.target.name]: value,
      })
    } else {
      setFields({
        ...fields,
        [event.name]: event.value,
      })
    }
  }

  if (status === 'done') {
    return <ConfirmationMessage className="text-dark" content={message} />
  }

  const matchOneSteps = form.formFields.slice(0, 5)
  const matchTwoSteps = form.formFields.slice(5)

  if (form.formFields) {
    return (
      <StyledForm
        id={`form_${gfForm.formId}`}
        className={className}
        method="post"
        onSubmit={handleOnSubmit}
      >
        {status === 'processing' && <Loading />}

        {gfForm.formId === 1 && ( // CONTACT FORM
          <div className="row">
            <div className="col-lg-6 pr-4">
              {form.formFields &&
                form.formFields.map((field: any, key: number) => {
                  if (
                    field.type !== 'textarea' &&
                    field.type !== 'submit' &&
                    field.type !== 'consent'
                  ) {
                    if (Array.isArray(field)) {
                      return (
                        <div key={key}>
                          {field.map((item, index) => (
                            <FormField
                              type={1}
                              key={index}
                              field={item}
                              fields={fields}
                              onChange={handleFieldChange}
                            />
                          ))}
                        </div>
                      )
                    }

                    return (
                      <div key={key}>
                        <FormField
                          type={1}
                          field={field}
                          fields={fields}
                          onChange={handleFieldChange}
                        />
                      </div>
                    )
                  }

                  return false
                })}
            </div>
            <div className="col-lg-6 pl-sm-4">
              {form.formFields &&
                form.formFields.map((field: any, key: number) => {
                  if (
                    field.type === 'textarea' ||
                    field.type === 'submit' ||
                    field.type === 'consent'
                  ) {
                    return (
                      <div key={key}>
                        <FormField
                          type={1}
                          field={field}
                          fields={fields}
                          onChange={handleFieldChange}
                        />
                      </div>
                    )
                  }

                  return false
                })}
            </div>
          </div>
        )}

        {gfForm.formId === 2 && ( // NIEUWSBRIEF FORM
          <div className="d-lg-flex align-items-center justify-content-between align-items-center">
            {form.formFields &&
              form.formFields.map((field: any, key: number) => (
                <div key={key} className="mx-3" style={{ minWidth: 250 }}>
                  <FormField
                    type={2}
                    field={field}
                    fields={fields}
                    onChange={handleFieldChange}
                  />
                </div>
              ))}
          </div>
        )}

        {gfForm.formId === 3 && ( // SOLLICITATIE FORM
          <div className="row">
            <div className="col-lg-6 pr-lg-4">
              {form.formFields &&
                form.formFields.map((field: any, key: number) => {
                  if (field.type !== 'fileupload') {
                    if (Array.isArray(field)) {
                      return (
                        <div key={key}>
                          {field.map((item, index) => (
                            <FormField
                              type={3}
                              key={index}
                              field={item}
                              fields={fields}
                              onChange={handleFieldChange}
                            />
                          ))}
                        </div>
                      )
                    }

                    return (
                      <div key={key}>
                        <FormField
                          type={3}
                          field={field}
                          fields={fields}
                          onChange={handleFieldChange}
                        />
                      </div>
                    )
                  }

                  return false
                })}
            </div>
            <div className="col-lg-6 pl-lg-4">
              {form.formFields &&
                form.formFields.map((field: any, key: number) => {
                  if (field.type === 'fileupload') {
                    return (
                      <>
                        <div key={key}>
                          <FormField
                            field={field}
                            fields={fields}
                            onChange={handleFieldChange}
                          />
                        </div>
                        {field.id === 6 && (
                          <FileInfo className="pl-4">
                            <b>Uploaden van bestanden:</b>
                            <br />
                            max. 5 mb per bestand. Is je bestand groter of wil
                            je een video toesturen? Dat kan! Mail naar{' '}
                            <a href="mailto:werkenbij@e-office.com">
                              werkenbij@e-office.com
                            </a>
                            .
                          </FileInfo>
                        )}
                      </>
                    )
                  }

                  return false
                })}
            </div>
          </div>
        )}
        {gfForm.formId === 4 && ( // VACATURE ALERT FORM
          <div className="d-lg-flex flex-column align-items-start justify-content-between alert-form">
            <AlertFormDesc className="text-white mb-5">
              {form.description}
            </AlertFormDesc>
            {form.formFields &&
              form.formFields.map((field: any, key: number) => (
                <div key={key}>
                  <FormField
                    type={4}
                    field={field}
                    fields={fields}
                    onChange={handleFieldChange}
                  />
                </div>
              ))}
          </div>
        )}

        {gfForm.formId === 5 && ( // MATCH PEOPLE FORM
          <div className="d-lg-flex flex-column align-items-start justify-content-between alert-form">
            <div className="flex mx-auto">
              <h3 className="block text-center">
                <span className="font-weight-bold">This or that </span>
                <span
                  className="font-weight-light"
                  style={{ fontSize: 18 }}
                >{`${matchStep + 1}/2`}</span>
              </h3>
              {matchStep === 0 && (
                <>
                  {form.formFields &&
                    matchOneSteps.map((field: any, key: number) => (
                      <div key={key} className="py-1">
                        <FormField
                          type={4}
                          field={field}
                          fields={fields}
                          onChange={handleFieldChange}
                        />
                      </div>
                    ))}
                  <div className="flex justify-content-center text-center mt-5">
                    <ButtonWhiteArrow
                      isCustom
                      to="#"
                      hasArrow
                      className="inline-block mx-auto"
                    >
                      <button
                        type="button"
                        onClick={() => setMatchStep((prev) => prev + 1)}
                      >
                        Volgende
                      </button>
                    </ButtonWhiteArrow>
                  </div>
                </>
              )}
              {matchStep === 1 && (
                <>
                  {form.formFields &&
                    matchTwoSteps.map((field: any, key: number) => (
                      <>
                        <div
                          key={key}
                          className={`${
                            key === matchTwoSteps.length - 1 ? 'mt-4' : 'mt-0'
                          } d-flex align-items-center justify-content-center`}
                        >
                          {key === matchTwoSteps.length - 1 && (
                            <button
                              onClick={() => setMatchStep((prev) => prev - 1)}
                              type="button"
                              className="mr-3"
                              style={{
                                fontSize: 19,
                                color: '#FFF',
                                fontWeight: 'bold',
                              }}
                            >
                              Terug
                            </button>
                          )}
                          <FormField
                            type={4}
                            field={field}
                            fields={fields}
                            onChange={handleFieldChange}
                          />
                        </div>
                      </>
                    ))}
                </>
              )}
            </div>
          </div>
        )}
      </StyledForm>
    )
  }

  return null
}

const StyledTextField = styled.div`
  padding-bottom: 20px;

  ${Label} {
    padding-left: 25px;
    padding-bottom: 10px;

    @media (max-width: 575px) {
      padding-left: 0;
    }
  }

  input {
    padding: 0 25px 0 25px;
    border-radius: 25px;
    height: 46px;
    width: 100%;
    border: 1px solid ${(props) => props.theme.color.border};
  }

  @media screen and (max-width: 575px) {
    padding-bottom: 0px;
  }
`

const TextField = ({
  value,
  onChange,
  field: { id, type, label, labelPlacement, placeholder, isRequired, cssClass },
}: any) => (
  <StyledTextField
    className={`form-group ${cssClass !== undefined ? cssClass : ''}`}
  >
    {labelPlacement !== 'hidden_label' && (
      <Label htmlFor={`input_${id}`}>
        {label}
        {isRequired && <Mandatory>*</Mandatory>}
      </Label>
    )}
    <input
      value={value}
      onChange={onChange}
      type="text"
      id={`input_${id}`}
      className={`${type} ${cssClass !== undefined ? cssClass : ''}`}
      name={`input_${id}`}
      required={isRequired}
      placeholder={placeholder}
    />
  </StyledTextField>
)

const StyledEmailField = styled.div`
  padding-bottom: 20px;

  ${Label} {
    padding-left: 25px;
    padding-bottom: 10px;
    @media (max-width: 575px) {
      padding-left: 0;
    }
  }

  input {
    padding: 0 25px 0 25px;
    border-radius: 25px;
    height: 46px;
    width: 100%;
    border: 1px solid ${(props) => props.theme.color.border};
  }

  @media screen and (max-width: 575px) {
    padding-bottom: 0px;
  }
`

const EmailField = ({
  value,
  onChange,
  field: { id, type, label, labelPlacement, placeholder, isRequired, cssClass },
}: any) => (
  <StyledEmailField className="form-group">
    {labelPlacement !== 'hidden_label' && (
      <Label htmlFor={`input_${id}`}>
        {label}
        {isRequired && <Mandatory>*</Mandatory>}
      </Label>
    )}
    <input
      value={value}
      onChange={onChange}
      type="email"
      id={`input_${id}`}
      className={`${type} ${cssClass !== undefined ? cssClass : ''}`}
      name={`input_${id}`}
      required={isRequired}
      placeholder={placeholder}
    />
  </StyledEmailField>
)

const StyledPhoneField = styled.div`
  padding-bottom: 20px;

  ${Label} {
    padding-left: 25px;
    padding-bottom: 10px;
    @media (max-width: 575px) {
      padding-left: 0;
    }
  }

  input {
    padding: 0 25px 0 25px;
    border-radius: 25px;
    height: 46px;
    width: 100%;
    border: 1px solid ${(props) => props.theme.color.border};
  }

  @media screen and (max-width: 575px) {
    padding-bottom: 0px;
  }
`

const PhoneField = ({
  value,
  onChange,
  field: { id, type, label, labelPlacement, placeholder, isRequired, cssClass },
}: any) => (
  <StyledPhoneField className="form-group">
    {labelPlacement !== 'hidden_label' && (
      <Label htmlFor={`input_${id}`}>
        {label}
        {isRequired && <Mandatory>*</Mandatory>}
      </Label>
    )}
    <input
      value={value}
      onChange={onChange}
      type="tel"
      id={`input_${id}`}
      className={`${type} ${cssClass !== undefined ? cssClass : ''}`}
      name={`input_${id}`}
      required={isRequired}
      placeholder={placeholder}
    />
  </StyledPhoneField>
)

const StyledTextAreaField = styled.div`
  padding-bottom: 20px;

  ${Label} {
    padding-left: 25px;
    padding-bottom: 10px;
    @media (max-width: 575px) {
      padding-left: 0;
    }
  }

  textarea {
    padding: 15px 25px 0 25px;
    border-radius: 25px;
    min-height: 166px;
    width: 100%;
    border: 1px solid ${(props) => props.theme.color.border};
  }

  @media screen and (max-width: 575px) {
    padding-bottom: 0px;
  }
`

const InputRadio = styled.input<{ active?: boolean }>`
  background-color: #fff;

  @media (min-width: 992px) {
    width: 24px;
    height: 24px;
  }

  @media (max-width: 991.98px) {
    width: 15px;
    height: 15px;
  }
`

const TextAreaField = ({
  value,
  onChange,
  field: { id, type, label, labelPlacement, placeholder, isRequired, cssClass },
}: any) => (
  <StyledTextAreaField className="form-group">
    {labelPlacement !== 'hidden_label' && (
      <Label htmlFor={`input_${id}`}>
        {label}
        {isRequired && <Mandatory>*</Mandatory>}
      </Label>
    )}
    <textarea
      value={value}
      onChange={onChange}
      id={`input_${id}`}
      className={`${type} ${cssClass !== undefined ? cssClass : ''}`}
      name={`input_${id}`}
      required={isRequired}
      placeholder={placeholder}
    />
  </StyledTextAreaField>
)

const CheckboxField = ({
  value,
  onChange,
  field: { id, type, cssClass, choices, label },
}: any) => {
  const list = JSON.parse(choices)

  return (
    <div className="form-group">
      <h4 className="text-white">{label}</h4>
      {list.map((checkbox: any, key: number) => (
        <div
          key={key}
          className="form-group__checkboxes d-flex align-items-center"
        >
          <input
            checked={value}
            onChange={onChange}
            type="checkbox"
            id={`input_${id}_${key + 1}`}
            className={`${type} ${cssClass !== undefined ? cssClass : ''}`}
            name={`input_${id}_${key + 1}`}
            value={checkbox.value}
          />
          <label
            htmlFor={`input_${id}_${key + 1}`}
            className="checkbox-content pl-5 mb-0"
          >
            {checkbox.text}
          </label>
        </div>
      ))}
    </div>
  )
}

const RadioField = ({
  value,
  onChange,
  field: { id, type, cssClass, choices },
}: any) => {
  const list = JSON.parse(choices)

  return (
    <div className="form-group my-4">
      <div className="d-flex align-items-center justify-content-center">
        {list.map((checkbox: any, key: number) => {
          const odd = key % 2 === 0

          return (
            <div
              key={key}
              className="form-group__checkboxes d-flex align-items-center"
            >
              {odd ? (
                <>
                  <LabelRadio
                    htmlFor={`input_${id}`}
                    className="checkbox-content text-lg-right pl-lg-5 mb-0 mr-2 mr-lg-5"
                  >
                    {checkbox.text}
                  </LabelRadio>
                  <InputRadio
                    onChange={onChange}
                    type="radio"
                    id={`input_${id}`}
                    className={`mr-4 ${type} ${
                      cssClass !== undefined ? cssClass : ''
                    }`}
                    name={`input_${id}`}
                    value={checkbox.value}
                  />
                </>
              ) : (
                <>
                  <InputRadio
                    active={value}
                    checked={value}
                    onChange={onChange}
                    type="radio"
                    id={`input_${id}`}
                    className={`${type} ${
                      cssClass !== undefined ? cssClass : ''
                    }`}
                    name={`input_${id}`}
                    value={checkbox.value}
                  />
                  <LabelRadio
                    htmlFor={`input_${id}`}
                    className="checkbox-content ml-2 ml-lg-5 mb-0"
                  >
                    {checkbox.text}
                  </LabelRadio>
                </>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}

const StyledSelect = styled.div``

// Select or Dropdown
const SelectField = ({ field, onChange, value }: any) => {
  // Populate a options array
  const options: Array<any> = []
  JSON.parse(field.choices).forEach((choice: any) => {
    options.push({
      value: choice.value,
      label: choice.text,
      type: 'select',
      name: `input_${field.id}`,
    })
  })

  // Custom Select component
  const MySelect = (props: any) => (
    <Select
      {...props}
      onChange={props.onChange}
      options={props.options}
      placeholder={props.placeholder}
    />
  )

  return (
    <StyledSelect>
      <MySelect
        options={options}
        onChange={onChange}
        value={options.filter((option) => option.value === value)}
        placeholder={field.label}
        classNamePrefix="react-select"
      />
    </StyledSelect>
  )
}

const SubmitButton = ({ formType, field }: any) => (
  <div>
    {formType === 1 && (
      <ButtonDefaultArrow to="/" isCustom>
        <button type="submit">{field.text}</button>
      </ButtonDefaultArrow>
    )}
    {formType === 2 && (
      <ButtonWhiteArrow to="submit" isCustom>
        <button type="submit">{field.text}</button>
      </ButtonWhiteArrow>
    )}
    {formType === 3 && (
      <ButtonWhiteArrow to="submit" isCustom>
        <button type="submit">{field.text}</button>
      </ButtonWhiteArrow>
    )}
    {formType === 4 && (
      <ButtonWhiteArrow to="submit" isCustom hasArrow>
        <button type="submit">{field.text}</button>
      </ButtonWhiteArrow>
    )}
  </div>
)

const StyledFileField = styled.div`
  margin-top: 40px;

  & label {
    border: 2px solid ${({ theme }) => theme.color.light};
    border-radius: 30px;
    padding: 15px 30px;
    font-weight: ${({ theme }) => theme.font.weight.bold};
    cursor: pointer;
    transition: all 0.3s ease;

    & svg {
      position: relative;
      bottom: unset;
      left: unset;
      width: initial;
      height: initial;
      opacity: 1;
      margin-right: 20px;
    }
  }

  & input {
    display: none;
  }

  &:hover {
    & label {
      box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
    }
  }
`

const FileField = ({
  value,
  onChange,
  field: {
    id,
    type,
    label,
    allowedExtensions,
    cssClass,
    isRequired,
    placeholder,
  },
}: any) => {
  function handleChange(file: any) {
    onChange({
      target: {
        name: `input_${id}`,
        value: file,
      },
    })
  }

  function handleFileUpload(e: any) {
    const {
      target: { files },
    } = e

    for (let i = 0; i < files.length; i += 1) {
      handleChange(files[i])
    }
  }

  function handleFileDrop(e: any) {
    e.preventDefault()

    if (e.dataTransfer.items) {
      // Use DataTransferItemList interface to access the file(s)
      for (let i = 0; i < e.dataTransfer.items.length; i += 1) {
        // If dropped items aren't files, reject them
        if (e.dataTransfer.items[i].kind === 'file') {
          handleChange(e.dataTransfer.items[i].getAsFile())
        }
      }
    } else {
      // Use DataTransfer interface to access the file(s)
      for (let i = 0; i < e.dataTransfer.files.length; i += 1) {
        handleChange(e.dataTransfer.files[i])
      }
    }
  }

  return (
    <StyledFileField
      className="form-upload"
      // eslint-disable-next-line react/jsx-no-bind
      onDrop={handleFileDrop}
      onDragOver={(e) => e.preventDefault()}
    >
      <Label htmlFor={`input_${id}`}>
        {value ? (
          value.name
        ) : (
          <>
            <Upload />
            {label}
          </>
        )}
        {isRequired && <WhiteMandatory>*</WhiteMandatory>}
      </Label>
      <input
        type="file"
        onChange={handleFileUpload}
        id={`input_${id}`}
        className={`${type} ${cssClass !== undefined ? cssClass : ''}`}
        name={`input_${id}`}
        required={isRequired}
        placeholder={placeholder}
        accept={allowedExtensions}
      />
    </StyledFileField>
  )
}

const ConsentLabel = styled.label``

const ConsentField = ({ onChange, value, field }: any) => {
  const list = JSON.parse(field.choices)

  return (
    <div className="form-group mt-4">
      <div
        key={field.id}
        className="form-group__checkboxes d-flex align-items-start"
      >
        <input
          checked={value}
          onChange={onChange}
          type="checkbox"
          id={`input_${field.id}`}
          className={`mt-1 mr-2 ${field.type} ${
            field.cssClass !== undefined ? field.cssClass : ''
          }`}
          name={`input_${field.id}`}
          value={list[0].value}
        />
        <ConsentLabel
          htmlFor={`input_${field.id}`}
          className="checkbox-content"
        >
          {`Ja, ik ga akkoord met het `}
          <CustomLink to="/privacyverklaring">privacy statement</CustomLink>
          {` van e-office`}
        </ConsentLabel>
      </div>
    </div>
  )
}

export const FormField = ({ type, field, fields, onChange }: any) => (
  <>
    {field.type === 'text' && (
      <TextField
        onChange={onChange}
        value={fields[`input_${field.id}`]}
        field={field}
      />
    )}
    {field.type === 'email' && (
      <EmailField
        onChange={onChange}
        value={fields[`input_${field.id}`]}
        field={field}
      />
    )}
    {field.type === 'phone' && (
      <PhoneField
        onChange={onChange}
        value={fields[`input_${field.id}`]}
        field={field}
      />
    )}
    {field.type === 'textarea' && (
      <TextAreaField
        onChange={onChange}
        value={fields[`input_${field.id}`]}
        field={field}
      />
    )}
    {field.type === 'checkbox' && (
      <CheckboxField
        onChange={onChange}
        value={fields[`input_${field.id}`]}
        field={field}
      />
    )}

    {field.type === 'radio' && (
      <>
        <RadioField
          onChange={onChange}
          // value={fields[`input_${field.id}_`]}
          field={field}
        />
      </>
    )}
    {field.type === 'select' && (
      <SelectField
        onChange={onChange}
        value={fields[`input_${field.id}`]}
        field={field}
      />
    )}
    {field.type === 'fileupload' && (
      <FileField
        onChange={onChange}
        value={fields[`input_${field.id}`]}
        field={field}
      />
    )}
    {field.type === 'consent' && (
      <ConsentField
        formType={type}
        onChange={onChange}
        value={fields[`input_${field.id}`]}
        field={field}
      />
    )}
    {field.type === 'submit' && (
      <>
        <SubmitButton field={field} formType={type} />
      </>
    )}
  </>
)

export default GravityForm
